import Vue from "vue";
import VueI18n from "vue-i18n";
import cookies from "js-cookie";
import enLocale from "./en";
import zhLocale from "./zh";
import ruLocale from "./ru";

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...ELEMENT.lang.en
  },
  zh: {
    ...zhLocale,
    ...ELEMENT.lang.zhCN
  },
  ru: {
    ...ruLocale,
    ...ELEMENT.lang.ruRU
  },
}
const i18n = new VueI18n({
  // locale: cookies.get("language") ? cookies.get("language") : process.env.VUE_APP_LOCAL, // set locale
  locale: 'zh',
  messages // set locale messages
})

export default i18n